import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';

@Component({
  selector: 'app-payment-method-dialog',
  templateUrl: './payment-method-dialog.component.html',
  styleUrls: ['./payment-method-dialog.component.css'],
})
export class PaymentMethodDialogComponent {
  constructor(public dialogRef: MatDialogRef<PaymentMethodDialogComponent>,
    public cssService: CssService,
  ) { }

  isClosing = false;
  selectedMethod: string | null = null;

  onCancel() {
    this.selectedMethod = null;
    this.isClosing = true;
  }

  onSelect(method: string): void {
    this.selectedMethod = method;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing) {
      this.dialogRef.close(this.selectedMethod);
    }
  }
}
